import agentEditComponent from './agent-edit.component';

const agentEditModule = angular.module('agentEdit', [
])
  .component('agentEdit', agentEditComponent)
  .name;

export default agentEditModule;
